import { lazy } from "react";
import { appPages } from "../context/pages.config";

const CompanyInfoPage = lazy(() => import("../page/admin/companyInfo/companyInfo"));

const AdminRoutes = [
  {
    path: appPages.salesAppPages.subPages.salesDashboardPage.to,
    element: <CompanyInfoPage />,
  },
  {
    path: appPages.salesAppPages.subPages.user.to,
    element: <CompanyInfoPage />,
  },
  {
    path: appPages.salesAppPages.subPages.locations.to,
    element: <CompanyInfoPage />,
  },
  {
    path: appPages.salesAppPages.subPages.equipments.to,
    element: <CompanyInfoPage />,
  },
  {
    path: appPages.salesAppPages.subPages.myAccount.to,
    element: <CompanyInfoPage />,
  },
  {
    path: appPages.salesAppPages.subPages.watchList.to,
    element: <CompanyInfoPage />,
  },
  {
    path: appPages.salesAppPages.subPages.adminTools.to,
    element: <CompanyInfoPage />,
  },
];

export default AdminRoutes;
